module.exports = __webpack_public_path__ + "static/media/nat-2.03315aa9.jpg";